import styled from 'styled-components'
import { SignForm } from '../SignInUp/SignInUp.styled'

export const RecoverForm = styled(SignForm)`
  margin-top: 25px;
`
